import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import FooterLink from '../Footer/FooterLink'
import FooterBar from '../Footer/FooterBar'

import Accordion from '../Accordion'

const useStyles = createUseStyles(theme => ({
    wrapper: {
        ...theme.wrappers.standard,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        '@media (max-width: 1200px)': {
            flexWrap: 'wrap',
            justifyContent: 'unset',
        },
    },

    footerBody: {
        backgroundColor: theme.colors.eggshell,
        paddingBottom: 85,
        paddingTop: 85,
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },

    footerTitle: {
        borderBottomStyle: 'solid',
        borderColor: theme.colors.brushedsteel,
        borderWidth: '0 0 1px',
        color: theme.colors.ocean,
        display: 'block',
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '0.89px',
        lineHeight: '19px',
        marginTop: 0,
        paddingBottom: 15,
        textAlign: 'left',
        textTransform: 'uppercase',
        width: 195,
    },

    footerColumn: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 244,
        minWidth: 200,
        '@media (max-width: 1200px)': {
            padding: 25,
        },
    },

    listStyle: {
        flexShrink: 0,
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        position: 'relative',
    },

    listItems: {
        color: theme.colors.shade,
        fontSize: 16,
        letterSpacing: '0.57px',
        lineHeight: '27px',
        position: 'relative',
    },

    footerMobile: {
        display: 'none',
        marginBottom: 5,
        '@media (max-width: 600px)': {
            display: 'block',
        },

        '&> div': {
            backgroundColor: theme.colors.eggshell,
            '&> div': {
                backgroundColor: theme.colors.eggshell,
            },

            '&> button': {
                backgroundColor: theme.colors.eggshell,
                '& p': {
                    fontSize: 16,
                    fontWeight: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: '0.44px',
                    color: theme.colors.coal,
                },
            },
        },
    },
}))

export const Footer = ({ navLinks, socialLinks, ctaText, ctaURI, termsURI, privacyURI }) => {
    const classes = useStyles()
    return (
        <footer>
            <div className={classes.footerBody}>
                <div className={classes.wrapper}>
                    {navLinks.map((nav, outsideIndex) => (
                        <div key={`h-l-1-${outsideIndex}`} className={classes.footerColumn}>
                            <h2 className={classes.footerTitle}>{nav.header}</h2>
                            <ul className={classes.listStyle}>
                                {nav.items.map((item, insideIndex) => (
                                    <li key={`h-l-2-${insideIndex}`} className={classes.listItems}>
                                        <FooterLink href={item.href}>{item.text}</FooterLink>
                                        <ul className={classes.listStyle}>
                                            {item.items &&
                                                item.items.map((subitem, subitem_index) => (
                                                    <li
                                                        key={`h-l-2-${insideIndex}-${subitem_index}`}
                                                        className={classes.listItems}
                                                    >
                                                        <FooterLink href={subitem.href}>
                                                            - {subitem.text}
                                                        </FooterLink>
                                                    </li>
                                                ))}
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className={classes.footerMobile}>
                {navLinks.map((nav, outsideIndex) => (
                    <Accordion key={`h-l-m-1-${outsideIndex}`} title={nav.header}>
                        {nav.items.map((item, insideIndex) => (
                            <React.Fragment key={`h-l-m-2-${insideIndex}`}>
                                <FooterLink href={item.href}>{item.text}</FooterLink>
                                <ul className={classes.listStyle}>
                                    {item.items &&
                                        item.items.map((subitem, subitem_index) => (
                                            <li
                                                key={`h-l-2-${insideIndex}-${subitem_index}`}
                                                className={classes.listItems}
                                            >
                                                <FooterLink href={subitem.href}>
                                                    - {subitem.text}
                                                </FooterLink>
                                            </li>
                                        ))}
                                </ul>
                            </React.Fragment>
                        ))}
                    </Accordion>
                ))}
            </div>
            <FooterBar btnText={ctaText} btnHref={ctaURI} socialLinks={socialLinks}>
                &copy; 2020 Ace Rental Cars
                <br />
                <a target="_blank" href={termsURI} rel="noreferrer">
                    Terms and Conditions
                </a>{' '}
                |{' '}
                <a target="_blank" href={privacyURI} rel="noreferrer">
                    Privacy Policy
                </a>
            </FooterBar>
        </footer>
    )
}

Footer.propTypes = {
    headers: PropTypes.array,
    columns: PropTypes.array,
    socialLinks: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            href: PropTypes.string,
        }),
    ),
    ctaText: PropTypes.string,
    ctaURI: PropTypes.string,
    termsURI: PropTypes.string,
    privacyURI: PropTypes.string,
}

export default Footer
